import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';

  const steps = [
  {
    label: 'Upload Cin7 Purchase Order Report',
    completedLabel: 'Cin7 Purchase Order Uploaded',
    description: 'Upload the CSV file generated from Cin7. We’ll process it to identify the items that need to be ordered from AGLC.'
  },
  {
    label: 'Download AGLC Order File',
    completedLabel: 'AGLC Order File Generated',
    description: 'Download the formatted product list ready to be submitted to AGLC for ordering.'
  },
  {
    label: 'Upload AGLC Confirmation File',
    completedLabel: 'AGLC Confirmation Uploaded',
    description: 'Upload the confirmation file received from AGLC. We’ll extract the products that were approved for delivery.'
  },
  {
    label: 'Download Cin7 Purchase Order File',
    completedLabel: 'Final Cin7 File Generated',
    description: 'Download the final CSV containing the approved products, ready to import into Cin7 as a new Purchase Order.'
  }
];

export default function HorizontalLinearStepper(props) {
  const { activeStep, completed = {} } = props;

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep} nonLinear completed={completed}>
        {steps.map((step, index) => {
          const isCompleted = !!completed[index];
          return (
            <Step key={step.label} completed={isCompleted} sx={{ px: 3 }}>
              <StepLabel sx={{ maxWidth: 120, whiteSpace: 'normal', textAlign: 'center' }}>
                {isCompleted ? step.completedLabel : step.label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <Typography sx={{ mt: 2, mb: 1, px: 3, pt: 3, textAlign: 'center', margin: '48px auto', minHeight: '48px' }}>
        {completed[activeStep] ? steps[activeStep]?.completedLabel : steps[activeStep]?.description}
      </Typography>
    </Box>
  );
}
